const API_URL = {
    LOGIN: `/v3/admin/login`,
    // REGISTER: ``,
    FORGOT_PASSWORD: `/v3/admin/forgot-password`,
    ME: `/v3/admin/me`,
    LOGOUT: `/v3/admin/logout`,
    CHANGE_PASSWORD: `/v3/admin/change-password`,
    UPDATE_PROFILE: `/v3/admin/update-profile`,
    RESET_PASSWORD: (otp: string): string => `/v3/admin/${otp}/reset-password`,

    // Common Api URL
    COMMON: {
        SYNC: `/v3/sync`,
        PRIVILEGES: `/v3/privileges-list`,
        COUNTRIES_LIST: `/v3/countries-list`,
        ROLES_LIST: (search: string): string =>
            `/v3/roles-list${search ? `?search=${search}` : ""}`,
    },
    CONTACTUS: {
        CREATE: `/v3/contact-us/create`,
    },
    NEWSLETTER: {
        CREATE: `/v3/news-letter/create`,
    },
    USER: {
        SIGNUP: `/v3/user/web_signup`,
    },
    DELETE_ACCOUNT: {
        DELETE: `/v3/delete-account`,
    },
    PAGE: {
        DETAILS: `/v3/pages/get_details`,
    },
};

export default API_URL;
